import React from 'react';

interface FormInputProps {
	label?: string;
	value: any;
	onChange: (newValue: any) => void;
}

const FormInput = (props: FormInputProps) => {
	return (
		<div className="formInput">
			{
				props.label && (
					<div className="formInput__label">
						<span>{props.label}</span>
					</div>
				)
			}
			<input
				className="formInput__input"
				value={props.value}
				onChange={(e: any) => props.onChange(e.currentTarget.value)}
			/>
		</div>
	);
};

export default FormInput;